import { connectorRowSlugs, type AppsController } from '../../../lib/use-connectors';
import { AvailableApps, ConnectedApps } from './AppsSection';
import { McpSection } from './McpSection';
import styles from './connectors.module.css';

/**
 * The Tools tab body — three full-width sections stacked beneath the genome band, each a three-per-row
 * grid of 1/3-pane cards (Figma 13936-134067): **Connected** first, then **Available to connect**, then
 * the **MCP servers**.
 *
 * Controller, search `query` and the MCP connect handoff are passed in from the page — one shared load
 * and one shared search field drive the whole screen.
 */
export function ConnectorsBody({
  apps,
  query,
  connectHandoff,
}: {
  apps: AppsController;
  query: string;
  connectHandoff: { route: string; path: string };
}) {
  return (
    <div className={styles.body}>
      <ConnectedApps query={query} controller={apps} />
      <AvailableApps query={query} controller={apps} />
      <McpSection query={query} bottomCta={connectHandoff} rowedSlugs={connectorRowSlugs(apps.state)} />
    </div>
  );
}
